import React from 'react';
import cx from 'classnames';
import { Carousel } from '@redturtle/qubicaamf-theme/components/Blocks/Listing/Carousel';
import config from '@plone/volto/registry';
import styles from '@redturtle/qubicaamf-theme/components/Blocks/Listing/Carousel/styles.module.css';

const CarouselTemplate = (props) => {
  const {
    headlineTag,
    items,
    isEditMode,
    autoplay,
    autoplay_speed,
    slides_to_show,
    display_dots,
    full_width,
    head_position,
    slide_appearance = 'default',
    sliderEffect3d,
    space_between,
    linkHref,
    ...data
  } = props;

  const getTitleTag = (tag) => {
    const level = tag.slice(-1);
    if (/\d/.test(level)) {
      return `h${Number(level) + 1}`;
    } else {
      return 'h3';
    }
  };
  const TitleTag = headlineTag ? getTitleTag(headlineTag) : 'h3';

  const SlideComponent =
    config.settings['volto-carousel'].slide_appearances?.[slide_appearance]
      ?.component;

  let carouselOptions = {
    slidesPerView: slides_to_show,
    displayDots: display_dots,
    autoHeight: true,
    spaceBetween: space_between ?? 0,
  };

  // if (autoplay) {
  //   carouselOptions.autoplay = true;
  //   carouselOptions.autoplayDelay = autoplay_speed * 1000;
  // }

  return (
    <div
      className={`ui container volto-carousel-template-wrapper head-position-${
        head_position ?? 'top'
      }`}
    >
      <Carousel
        items={items}
        slideComponent={({ item, index }) => (
          <SlideComponent
            item={item}
            index={index}
            TitleTag={TitleTag}
            isEditMode={isEditMode}
            data={data}
          />
        )}
        full_width={full_width}
        className={slide_appearance}
        isEditMode={isEditMode}
        {...carouselOptions}
      />
      {data.block_description && (
        <div
          className={cx(
            'carousel-block-description',
            styles.carouselDescription,
          )}
        >
          {data.block_description}
        </div>
      )}
    </div>
  );
};

export default CarouselTemplate;
